module.exports = __webpack_public_path__ + "static/media/annual-special-offer-image-bg.8df9e420.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/annual-special-offer-image-bg.jpg
// module id = 2208
// module chunks = 0